import { Component, Input, OnInit } from '@angular/core';
import { ContentService } from '@blk/cwp-ng-framework';
import { TealiumAnalyticsEvent, TealiumAnalyticsService } from '@ddt-web/analytics';
import { DialogService } from '@ddt-web/dialog';
import { SlugifyPipe } from '@ddt-web/generic-utils';
import { TourDialogComponent, TourDialogContent } from '@ddt-web/new-feature-highlights';
import * as toUpper from 'lodash/toUpper';

@Component({
	selector: 'ac-take-tour-link',
	templateUrl: './take-tour-link.component.html',
	styleUrls: ['./take-tour-link.component.scss']
})
export class TakeTourLinkComponent implements OnInit {

	@Input() public page: string;
	@Input() public iconType: string = 'question-circle';

	public dcrPrefix: string;
	public tourDialogContent: TourDialogContent[] = [];

	constructor(
		private dialogService: DialogService,
		private contentService: ContentService,
		private tealiumAnalyticsService: TealiumAnalyticsService
	) { }

	public ngOnInit(): void {
		const slugifyPipe: SlugifyPipe = new SlugifyPipe();

		this.dcrPrefix = 'TOUR_' + toUpper(slugifyPipe.transform(this.page, '_'));

		const maxPagesCheck = +this.contentService.get('TOUR_MAX_PAGES_CHECK', '10');
		for (let i = 1; i <= maxPagesCheck; i++) {
			const isTitlePresent = !!this.contentService.get(`${this.dcrPrefix}_${i}_TITLE`, '').trim();
			if (isTitlePresent) {
				this.tourDialogContent.push({
					icon: this.contentService.get(`${this.dcrPrefix}_${i}_ICON`, ''), // TOUR_STEP_1_1_ICON
					title: this.contentService.get(`${this.dcrPrefix}_${i}_TITLE`, ''), // TOUR_STEP_1_1_TITLE
					description: this.contentService.get(`${this.dcrPrefix}_${i}_DESCRIPTION`, ''), // TOUR_STEP_1_1_DESCRIPTION
					image: this.contentService.get(`${this.dcrPrefix}_${i}_IMAGE`, ''), // TOUR_STEP_1_1_IMAGE
					video: this.contentService.get(`${this.dcrPrefix}_${i}_VIDEO`, '') // TOUR_STEP_1_1_VIDEO
				} as TourDialogContent);
			}
		}
	}

	public openTakeATourDialog(): void {
		this.tealiumAnalyticsService.trackEventTealium(
			new TealiumAnalyticsEvent(
				this.page + ':take-a-tour:open',
				null
			)
		);

		this.dialogService.open(TourDialogComponent, {
			data: {
				featureName: this.dcrPrefix,
				tourDialogContent: this.tourDialogContent
			}
		});
	}

}
